//
//
//
//
//
//
//
//

export default {
  name: 'KnockLayoutDefault'
};
